export default __webpack_public_path__ + "static/scalability_icon-9c32aa8f69916a27fc6198ef7abb2b23.svg";